export default "__VITE_ASSET__DdfmRPIg__"